<template>
  <header class="navbar">
    <div class="navbar__left">
      <el-button class="navbar__collapse" :icon="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="$store.commit('app/TOGGLE_SIDEBAR')" />
      <div class="navbar__page-meta">
        <strong>{{ currentTitle }}</strong>
        <div>
          <span>智能云剪辑</span><i>/</i><small>{{ currentTitle }}</small>
        </div>
      </div>
    </div>
    <div class="navbar__right">
      <el-select v-if="stores.length" v-model="storeId" class="navbar__store" filterable placeholder="选择门店" @change="changeStore">
        <el-option v-for="item in stores" :key="item.storeId" :label="item.name || `门店 ${item.storeId}`" :value="item.storeId"
          ><span>{{ item.name || `门店 ${item.storeId}` }}</span
          ><small>{{ item.tradeName }}</small></el-option
        >
      </el-select>
      <el-popover placement="bottom-end" width="340" trigger="click" popper-class="console-popover">
        <div class="command-panel">
          <strong>搜索菜单或功能</strong>
          <el-input v-model.trim="menuKeyword" prefix-icon="el-icon-search" clearable placeholder="输入菜单名称或访问路径" />
          <div class="command-list">
            <button v-for="item in filteredMenuItems" :key="item.path" type="button" @click="goTo(item.path)">
              <i :class="item.icon" /><span>{{ item.title }}</span
              ><small>{{ item.path }}</small>
            </button>
            <div v-if="!filteredMenuItems.length" class="command-empty">没有匹配的菜单</div>
          </div>
        </div>
        <el-button slot="reference" class="navbar__search" icon="el-icon-search">搜索菜单或功能</el-button>
      </el-popover>
      <el-popover placement="bottom" width="230" trigger="click" popper-class="console-popover">
        <div class="quick-panel">
          <strong>快捷入口</strong>
          <button v-for="item in quickItems" :key="item.path" type="button" @click="goTo(item.path)">
            <i :class="item.icon" /><span>{{ item.title }}</span>
          </button>
        </div>
        <el-button slot="reference" class="navbar__icon" icon="el-icon-guide" />
      </el-popover>
      <el-tooltip content="界面设置" placement="bottom">
        <el-button class="navbar__icon" icon="el-icon-setting" @click="settingsVisible = true" />
      </el-tooltip>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="navbar__user">
          <span class="navbar__avatar">{{ avatarText }}</span>
          <span class="navbar__username">{{ displayName }}</span>
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item icon="el-icon-user">个人信息</el-dropdown-item> -->
          <el-dropdown-item command="logout" icon="el-icon-switch-button" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <theme-settings v-model="settingsVisible" />
    <el-dialog title="菜单显示设置" :visible.sync="menuSettingsVisible" width="520px" append-to-body custom-class="menu-visibility-dialog">
      <div class="menu-visibility-list">
        <div v-for="item in allMenuItems" :key="item.path" class="menu-visibility-item">
          <span
            ><i :class="item.icon" /><strong>{{ item.title }}</strong
            ><small>{{ item.path }}</small></span
          >
          <el-switch :value="isMenuVisible(item.path)" @input="setMenuVisibility(item.path, $event)" />
        </div>
      </div>
      <span slot="footer"><el-button @click="resetMenuVisibility">恢复默认</el-button><el-button type="primary" @click="menuSettingsVisible = false">完成</el-button></span>
    </el-dialog>
  </header>
</template>

<script>
import ThemeSettings from '@/components/ThemeSettings/index.vue';
import { asyncRoutes } from '@/router';
import { getStoreList } from '@/api/content';
import { getStoreId, setStoreId } from '@/utils/business-context';
import { preferenceDefaults } from '@/utils/preferences';

export default {
  name: 'AppNavbar',
  components: { ThemeSettings },
  data() {
    return { settingsVisible: false, menuSettingsVisible: false, menuKeyword: '', stores: [], storeId: getStoreId() || null };
  },
  computed: {
    collapsed() {
      return this.$store.state.app.preferences.sidebarCollapsed;
    },
    userInfo() {
      return this.$store.state.user.userInfo || {};
    },
    displayName() {
      return this.userInfo.name || this.userInfo.username || '管理员';
    },
    avatarText() {
      return this.displayName.slice(0, 1).toUpperCase();
    },
    currentTitle() {
      return (this.$route.meta && this.$route.meta.title) || '工作台';
    },
    menuItems() {
      return this.filterServerMenus(this.flattenRoutes(asyncRoutes));
    },
    hiddenMenus() {
      return this.$store.state.app.preferences.hiddenMenus || [];
    },
    menuVisibility() {
      return this.$store.state.app.menuVisibility || {};
    },
    allMenuItems() {
      return this.filterServerMenus(this.flattenRoutes(asyncRoutes, '', true));
    },
    filteredMenuItems() {
      const keyword = this.menuKeyword.toLowerCase();
      if (!keyword) return this.menuItems;
      return this.menuItems.filter((item) => item.title.toLowerCase().includes(keyword) || item.path.toLowerCase().includes(keyword));
    },
    quickItems() {
      return this.menuItems.slice(0, 4);
    }
  },
  created() {
    window.addEventListener('business-store-change', this.handleStoreChange);
    this.loadStores();
  },
  beforeDestroy() {
    window.removeEventListener('business-store-change', this.handleStoreChange);
  },
  methods: {
    handleStoreChange(event) {
      this.storeId = Number(event.detail.storeId);
    },
    loadStores() {
      getStoreList()
        .then((data) => {
          this.stores = (data && data.list) || [];
          const exists = this.stores.some((item) => item.storeId === this.storeId);
          if (!exists && this.stores.length) {
            this.storeId = this.stores[0].storeId;
            setStoreId(this.storeId);
          }
        })
        .catch(() => {});
    },
    changeStore(value) {
      setStoreId(value);
      this.$message.success('已切换门店');
    },
    flattenRoutes(routes, parentPath = '', includeHidden = false) {
      return routes.reduce((items, route) => {
        if (!includeHidden && route.meta && route.meta.hidden) return items;
        const path = route.path.startsWith('/') ? route.path : `${parentPath}/${route.path}`.replace(/\/+/g, '/');
        if (route.children && route.children.length) {
          const visibleChildren = includeHidden ? route.children : route.children.filter((child) => !child.meta || !child.meta.hidden);
          if (visibleChildren.length === 1 && visibleChildren[0].path === '') {
            if (!visibleChildren[0].meta || !visibleChildren[0].meta.hidden) items.push({ path, title: visibleChildren[0].meta.title, icon: visibleChildren[0].meta.icon });
          } else {
            items.push(...this.flattenRoutes(visibleChildren, path, includeHidden));
          }
        }
        return items;
      }, []);
    },
    goTo(path) {
      this.menuKeyword = '';
      if (!getStoreId()) {
        window.dispatchEvent(new CustomEvent('open-store-setup'));
        return;
      }
      if (path !== this.$route.path) this.$router.push(path);
    },
    isMenuVisible(path) {
      return !this.hiddenMenus.includes(path);
    },
    filterServerMenus(items) {
      return items.filter((item) => this.menuVisibility[item.path] !== false);
    },
    setMenuVisibility(path, visible) {
      const hiddenMenus = this.hiddenMenus.filter((item) => item !== path);
      if (!visible) hiddenMenus.push(path);
      this.$store.commit('app/SET_PREFERENCE', { key: 'hiddenMenus', value: hiddenMenus });
    },
    resetMenuVisibility() {
      this.$store.commit('app/SET_PREFERENCE', { key: 'hiddenMenus', value: [...preferenceDefaults.hiddenMenus] });
    },
    handleCommand(command) {
      if (command === 'menu-settings') {
        this.$store.dispatch('app/loadMenuVisibility').finally(() => {
          this.menuSettingsVisible = true;
        });
        return;
      }
      if (command !== 'logout') return;
      this.$confirm('确定退出当前账号吗？', '退出登录', { type: 'warning' })
        .then(() => this.$store.dispatch('user/logout'))
        .then(() => this.$router.replace('/login'))
        .catch(() => {});
    }
  }
};
</script>
